import cn from 'classnames';

interface CharCounterProps {
  value?: string | null;
  max: number;
  min?: number;
  className?: string;
}

export const CharCounter = ({ value, max, min, className }: CharCounterProps) => {
  const count = (value ?? '').trim().length;
  const isOutOfRange = count > max || (min !== undefined && count > 0 && count < min);

  return (
    <p
      className={cn(
        'text-xs text-right tabular-nums',
        isOutOfRange ? 'text-red-tertiary' : 'text-grey-secondary',
        className,
      )}
    >
      {count}/{min !== undefined ? `${min}–${max}` : max}
    </p>
  );
};
